<template>
  <div class="popup" v-show="visible">
      <div class="popup--inner">
          <h2 class="popup--title">
              Deleting {{resource}} is permanent
          </h2>
          <p class="popup--paragraph">
              Once deleted, {{resource}} cannot be reverted. Think twice.
          </p>
          <div class="popup--buttons">
              <button class="popup--buttons-item btn btn_grey btn_stroke" v-on:click="close">
                  Cancel
              </button>
              <button class="popup--buttons-item btn btn_green" v-on:click="confirm">
                  Confirm
              </button>
          </div>
      </div>
  </div>
</template>
<script>
  import Popup from 'vue-popup';
  require('vue-popup/lib/popup.css');
  export default {
      mixins: [Popup],
      props: {
        visible: false,
        resource: '',
        modal: {
          default: true
        },
        closeOnClickModal: {
          default: true
        }
      },
      methods: {
        close() {
          this.$parent.confirmToggle();
        },
        confirm(){
          this.$parent.confirmAccept();
        }
      }
    };
</script>


// WEBPACK FOOTER //
// modal_confirm.vue?4f73d413